import { Component, Input } from '@angular/core';
import { Router } from '@angular/router';
import { RouterHelperService } from '@shared/services/router-helper.service';

@Component({
    selector: 'app-footer-component',
    templateUrl: './footer.component.html',
    styleUrls: ['footer.component.scss'],
    providers: [{ provide: Window, useValue: window }],
})
export class FooterComponent {
    displayLegalesModal = false;
    displayPrivacyModal = false;
    displayAccesibilite = false;

    constructor(private router: Router, private window: Window) {}

    isDisplayFooterLegalsLcl(): boolean {
        return this.router.isActive(RouterHelperService.urlSepaMandate, false);
    }
    openPrivacyCenter() {
        this.window.tC.privacy.showPrivacyCenter();
    }
}
